<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hdirectorio">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>DIRECTORIO</h1>
                    <p>En la Fundación Best nos es grato tener contacto directo con usted, por lo que dejamos a su disposición nuestros contactos.</p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>

    <div class="FcfrCst">
        <div class="FcfrCstInt flx dSieteM dtDiez dmDoce">
            <div class="dOcho dmOnce FdirAzul">
                <h3>Oficina  Corporativa</h3>
                <p class="FcifrasDatos">Av. Independencia No. 26, Col. Independencia, Ciudad de México, C. P. 03630<br>
                    Conmutador: 55 54 22 46 20 Lada sin costo: 800 508 3580</p>
            </div>
        </div>
    </div>
    <div class="espacioDefault"></div>
    <div class="FlstDr">
        <table class="Ftabla dNueve dtDiez dmOnce" >
            <tr>
                <th></th>
                <th>TELÉFONO</th>
                <th>EXT.</th>
                <th>CORREO ELECTRÓNICO</th>
            </tr>
            <tr></tr>
            <tbody *ngFor="let directorio of directorios">
                <tr>
                    <td>{{directorio.cargo}}</td>
                    <td>{{directorio.telefono}}</td>
                    <td>{{directorio.extension}}</td>
                    <td>{{directorio.correo}}</td>
                </tr>
                <tr></tr>
            </tbody>
        </table>
    </div>
    <!-----

    <div class="FtblDr dNueve dtDiez dmOnce">
        <h2>GERENCIAS POR ZONA MÉDICA<br><span>Seleccione su zona para ver los datos de las gerencias. </span></h2><br>
        <div class="FtblDrTabs flx">
            <div class="dUnoM"></div>
            <div class="dTres FnoActivo Factivo" id="tabN"  [ngClass]="{'FnoActivoP':activo=='segundo' || activo=='tercero'}" (click)="activo='primero'">NORTE</div>
            <div class="dTres FnoActivo" id="tabC"          [ngClass]="{'Factivo':activo=='segundo'}" (click)="activo='segundo'">CENTRO</div>
            <div class="dTres FnoActivo" id="tabS"          [ngClass]="{'Factivo':activo=='tercero'}" (click)="activo='tercero'">SUR</div>
            <div class="dUnoM"></div>
        </div>
        <div class="FdirNorte FblqActivo" id="FdirNorte"  [ngClass]="{'FblqnoActivoP':activo=='segundo' || activo=='tercero'}">
            <div class="FlstDr">
                <table class="Ftabla Ftablon dDoce">
                    <tr>
                        <th>ESTADO</th>
                        <th>CORREO ELECTRÓNICO</th>
                        <th>TELÉFONOS</th>
                    </tr>
                    <tr></tr>
                    <tbody class="tablaBlq" *ngFor="let norte of nortes">
                        <tr>
                            <td>{{norte.estado}}</td>
                            <td>{{norte.correo}}</td>
                            <td>{{norte.telefono}}</td>
                        </tr>
                        <tr></tr>
                    </tbody>

                </table>
            </div>      
        </div>
        <div class="FdirCentro FblqnoActivo" id="FdirCentro"  [ngClass]="{'FblqActivo':activo=='segundo'}">
            <div class="FlstDr">
                <table class="Ftabla Ftablon dDoce">
                    <tr>
                        <th>ESTADO</th>
                        <th>CORREO ELECTRÓNICO</th>
                        <th>TELÉFONOS</th>
                    </tr>
                    <tr></tr>
                    <tbody class="tablaBlq" *ngFor="let centro of centros">
                        <tr>
                            <td>{{centro.estado}}</td>
                            <td>{{centro.correo}}</td>
                            <td>{{centro.telefono}}</td>
                        </tr>
                        <tr></tr>
                    </tbody>
                </table>
            </div>      
        </div>
        <div class="FdirSur FblqnoActivo" id="FdirSur"  [ngClass]="{'FblqActivo':activo=='tercero'}">
            <div class="FlstDr">
                <table class="Ftabla Ftablon dDoce">
                    <tr>
                        <th>ESTADO</th>
                        <th>CORREO ELECTRÓNICO</th>
                        <th>TELÉFONOS</th>
                    </tr>
                    <tr></tr>
                    <tbody class="tablaBlq" *ngFor="let sur of surs">
                        <tr>
                            <td>{{sur.estado}}</td>
                            <td>{{sur.correo}}</td>
                            <td>{{sur.telefono}}</td>
                        </tr>
                        <tr></tr>
                    </tbody>
                </table>
            </div>      
        </div>
    </div>---->

</div>
